import * as Sentry from '@sentry/react';
import componentErrorBg from '@/assets/component-error-bg.jpg';
import ErrorPage from '@/components/ErrorMessage';
import PageLayout from '@/components/general/PageLayout';

type GenericErrorProps = {
  children: JSX.Element;
};

const FallbackUI = (): JSX.Element => {
  return (
    <PageLayout>
      <ErrorPage
        description="We were not able to process your request. Use the menu above to navigate to a different page."
        title="Something went wrong"
        illustration={componentErrorBg}
      />
    </PageLayout>
  );
};

const GenericError = ({ children }: GenericErrorProps): JSX.Element => {
  return <Sentry.ErrorBoundary fallback={FallbackUI}>{children}</Sentry.ErrorBoundary>;
};

export default GenericError;
